import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from '../../../constants/constants';

const CardButton = ({ identity }) => {
  const { t } = useTranslation();
  const { flowId, stepId, userId } = identity;

  return (
    <>
      <Grid item>
        <Button
          component={RouterLink}
          variant={(identity.status === CONSTANTS.IDENTITY.STATUS.REGISTERED) ? 'contained' : 'outlined'}
          color='primary'
          to={{ pathname: `/bioadmin/${flowId}/${stepId}/${userId}` }}
        >
          {t('identityListView:viewIdentity')}
        </Button>
      </Grid>
    </>
  );
};

const IdentityMenu = (props) => {
  const { identity } = props;

  return (
    <>
      <CardButton
        identity={identity}
      />
    </>
  );
};

export default IdentityMenu;
